import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { OnboardingTutorialComponent } from 'src/app/core/helper/components/onboarding-tutorial/onboarding-tutorial.component';

import { AuthPage } from './auth.page';
import { WelcomePageComponent } from './components/welcome-page/welcome-page.component';

const routes: Routes = [
  {
    path: 'login-register',
    component: AuthPage
  },
  {
    path: 'on-boarding',
    component: OnboardingTutorialComponent
  },
  {
    path:'welcome-page',
    component:WelcomePageComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthPageRoutingModule {}
